import React, { Component } from "react";
import { connect } from "react-redux";

//COMPONENTI MATERIAL UI
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import { Grid, Row, Col }                    from 'react-material-responsive-grid';
import MenuItem                              from "material-ui/MenuItem";
import { RadioButton, RadioButtonGroup }     from "material-ui/RadioButton";
import RaisedButton                          from "material-ui/RaisedButton";
import Toggle                                from 'material-ui/Toggle';
import Dialog                                from 'material-ui/Dialog';
import SelectField                           from "material-ui/SelectField";
import DatePicker                            from "material-ui/DatePicker";
import TextField                             from "material-ui/TextField";
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRowColumn, TableRow, TableFooter } from "material-ui/Table";
//IMPORT COMPONENT
import Menu         from "../Components/component_Menu";
import Loader       from "../Components/component_Loader";
import ErrorMessage from "../Components/component_MsgError";
import GoToLogin    from "../Components/component_GoToLogin";
//ACTIONS
import { getHoldingList, orderListaHolding, setHolding }                     from "../Actions/Action_ServiceRequest_Holding";
import { getUserInfo } from "../Actions/Action_Authentication";
//ICON
import IconArrowUp   from "material-ui/svg-icons/navigation/arrow-drop-up";
import IconArrowDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import IconFilter    from "material-ui/svg-icons/content/filter-list";
import IconEdit      from "material-ui/svg-icons/editor/mode-edit";
import IconAdd       from "material-ui/svg-icons/content/add";
import IconDelete    from "material-ui/svg-icons/action/delete";
import IconShow      from "material-ui/svg-icons/image/remove-red-eye";
import IconRefresh   from "material-ui/svg-icons/navigation/refresh";
import IconDeleteFilter from "material-ui/svg-icons/content/delete-sweep";
import IconLabel     from "material-ui/svg-icons/action/label";
//UTILS
import * as ROLES  from "../Utils/Roles_Types.js";
import * as STYLES from "../Utils/Styles.js";
import momentformat from "moment";
import { checkStrForm, checkUserLanguage } from "../Utils/Check_Value";
import { LABEL_Required, LABEL_NoResult, LABEL_Close, LABEL_Cancel, LABEL_Save, LABEL_OrderBy, LABEL_NoExpiryDate, LABEL_Days, 
         LABEL_Description, LABEL_Name, LABEL_ExpiredLicense, LABEL_Expiring, LABEL_Expiration,LABEL_StartExpiration,LABEL_EndExpiration,
         LABEL_Enter_Description, LABEL_Enter_Name, LABEL_PAGE_Holding, LABEL_DIALOG_HoldingNew, LABEL_DIALOG_HoldingModify, LABEL_NumberDays } from "../Utils/Strings/Labels";
//USERINFO
const USERINFO = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERIDHOLDING = USERINFO == null ? null: USERINFO.Holding == null ? null : USERINFO.Holding.ID;
const USERIDAZIENDA = USERINFO == null ? null: USERINFO.Azienda == null ? null : USERINFO.Azienda.ID;
const USERLANGUAGE  = checkUserLanguage(USERINFO);

var TIMER = null;

const styles = {
  color : {
    scaduta : "#ff4e42",
    inScadenza : "#fdffd1"
  },
  propContainer: {
    width: 200,
    overflow: "hidden",
    margin: "20px auto 0"
  },
  filterDialog: {
    width: "100%",
    maxWidth: "none"
  },
  filterRow: {
    marginBottom: "20px"
  },
  addModifyToggle: {
    color: "#6b9add"
  }
};

var emptyHoldingModel = {
    Nome        : null,
    Descrizione : null,
    Scadenza    : null
}


class Holding extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //Table
      fixedHeader: true,
      fixedFooter: true,
      stripedRows: false,
      showRowHover: true,
      selectable: true,
      multiSelectable: false,
      enableSelectAll: false,
      deselectOnClickaway: false,
      showCheckboxes: false,
      height: '470px',
      selectedList : [],
      //SORT
      ordinaPer : null,
      filter: {
        ID                 : null,
        Nome               : null,
        Descrizione        : null,
        DataInizioScadenza : null,
        DataFineScadenza  : null
      },
      //Modal per aggiungere o modificare
      showAddModify : {
        opened : false,
        data   : JSON.parse(JSON.stringify(emptyHoldingModel)),
        modify : true
      },
      todayDate : momentformat().format()
    }
  }

  
  isSelectedRow      = index => this.state.selectedList.indexOf(index) !== -1;
  handleRowSelection = row   => this.setState({ selectedList : row });

  handleOrderChange = (event, index, value) => {
    this.setState({ordinaPer : value});
    this.props.dispatch(orderListaHolding(this.props.holdingList, value));
  };

  setTimerForText = () => {
    if(TIMER != null)
      clearTimeout(TIMER);
    TIMER = setTimeout(() => {
      this.props.dispatch(getHoldingList(this.state.filter));
    }, 500);
  };

  //Dialog aggiunta modifica campo personalizzato
  handleOpenAddModifyOnlyRead = () => {
    this.handleOpenAddModify(true);
  }
  handleOpenAddModify = (modify = false) => {
    var showAddModify = this.state.showAddModify;
    if(this.state.selectedList.length === 1){
      showAddModify.data = JSON.parse(JSON.stringify(this.props.holdingList[this.state.selectedList[0]]));
    }else{
      showAddModify.data = JSON.parse(JSON.stringify(emptyHoldingModel));
    }
    showAddModify.opened = true;
    showAddModify.modify = modify;
    this.setState({showAddModify : showAddModify});
  };
  handleCloseAddModify = () => {
    var showAddModify = this.state.showAddModify;
    showAddModify.opened = false;
    this.setState( { showAddModify : showAddModify } );
  };
  handleCloseAddModifyWithSave = () => {
    //Controllo i campi
    var flag = true;
    var showAddModify = this.state.showAddModify;
    //NOME
    showAddModify.data.msgErrorNome       = checkStrForm(showAddModify.data.Nome);
      if( showAddModify.data.msgErrorNome != null ) flag = false;
    //DESCRIZIONE
    showAddModify.data.msgErrorDescrizione  = checkStrForm(showAddModify.data.Descrizione);
      if( showAddModify.data.msgErrorDescrizione != null ) flag = false;
    if(showAddModify.data.Scadenza == null) {
      flag = false;
      showAddModify.data.msgErrorScadenza = LABEL_Required[USERLANGUAGE];
    }
    
    if(flag){
      showAddModify.opened = false;
      showAddModify.data.Scadenza = momentformat(new Date(showAddModify.data.Scadenza)).format("YYYY-MM-DDTHH:mm:ss");
      this.props.dispatch(setHolding(showAddModify.data));//mando al servizio i dati
    }else this.setState( { showAddModify : showAddModify } );
  };
  handleOnChangeAddModifyText = (value, position) => {
    var showAddModify = this.state.showAddModify;
    if(value === null || value.trim() === ""){
      showAddModify.data["msgError"+position] = LABEL_Required[USERLANGUAGE];
    }else showAddModify.data["msgError"+position] = "";
    showAddModify.data[position] = value;
    this.setState( { showAddModify : showAddModify } );
  };
  handleOnChangeAddModifyScadenza = (event, date) => {
    var showAddModify = this.state.showAddModify;
    showAddModify.data.Scadenza = date;
    if(date != null)
      showAddModify.data.msgErrorScadenza = null; 
    this.setState({showAddModify: showAddModify });
  }

  //FILTRI DATA
  handleChangeFilterDate = (date, position) => {
    var filter = this.state.filter;
    filter["_"+position] = date;
    this.setState({filter:filter});
    filter[position] = momentformat(filter["_"+position]).format("YYYY-MM-DD");
    this.props.dispatch(getHoldingList(filter));
  } 

  //Per intercettare il cambio di filtri testuali
  handleOnFilterTextChange = (value, position) => {
    var filter = this.state.filter;
    filter[position] = value;
    this.setTimerForText();
    this.setState({ filter : filter});
  };

  handleDeleteAllFilters = () =>{
    var filter =  {
        ID                  : null,
        Nome                : null,
        Descrizione         : null,
        DataInizioScadenza  : null,
        DataFineScadenza   : null,
        _DataInizioScadenza : null,
        _DataFineScadenza  : null 
      };
    this.setState({filter:filter});
    this.props.dispatch(getHoldingList(filter));
  }

  dateDifferenceToday(date){
    var today = momentformat();
    var to    = momentformat(date);
    return today.diff(to, 'days');
  }

  getRowColorFrom(scadenza){
    var diffDay = this.dateDifferenceToday(scadenza)
    if(diffDay < -30)//mancano piu di 30 giorni
      return "none";
    if(diffDay > -30 && diffDay < 0) // -> in scadenza
      return styles.color.inScadenza;
    else
      return styles.color.scaduta;
  }

  componentDidMount(){
    this.props.dispatch(getUserInfo());
    this.props.dispatch(getHoldingList(this.state.filter));
  };

  render() {

    if(this.props.toRefreshOnRender)
          this.props.dispatch(getHoldingList(this.state.filter));
    var addModifyDialogAction = null;

    if(this.state.showAddModify.modify == true){
      addModifyDialogAction = [
      <RaisedButton
        label={LABEL_Close[USERLANGUAGE]}
        primary={false}
        onClick={this.handleCloseAddModify}
      />,
    ];
    }else{
      addModifyDialogAction = [
        <RaisedButton
          label={LABEL_Cancel[USERLANGUAGE]}
          primary={false}
          onClick={this.handleCloseAddModify}
        />,
        <RaisedButton
          label={LABEL_Save[USERLANGUAGE]}
          primary={true}
          onClick={this.handleCloseAddModifyWithSave}
      />];
    }
    
    return <div>
        <Menu dispatch={this.props.dispatch} pageName={LABEL_PAGE_Holding[USERLANGUAGE]} Language={USERLANGUAGE}/>
        <ErrorMessage message={this.props.errorMessage} />
        <GoToLogin isAuthenticated = {USERINFO.Role.ID === ROLES.ADMINISTRATOR_IS_ID && this.props.isAuthenticated}/>
        <div className="my-body">
            <Grid>
                  <Row style={styles.filterRow}>
                    <Col sm12={3}>
                        <TextField className="input-label"
                            onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Nome" ) }
                            hintText          ={LABEL_Enter_Name[USERLANGUAGE]}
                            floatingLabelText ={LABEL_Name[USERLANGUAGE]}
                            value             ={this.state.filter.Nome == null ? "" : this.state.filter.Nome}/>
                    </Col>
                    <Col sm12={3}>
                        <TextField className="input-label"
                            onChange          = { event => this.handleOnFilterTextChange( event.target.value, "Descrizione" ) }
                            hintText          = {LABEL_Enter_Description[USERLANGUAGE]}
                            floatingLabelText = {LABEL_Description[USERLANGUAGE]}
                            value             = {this.state.filter.Descrizione == null ? "" : this.state.filter.Descrizione}/>
                    </Col>
                    <Col sm12={3}>
                        <DatePicker
                          floatingLabelText={LABEL_StartExpiration[USERLANGUAGE]}
                          autoOk    = {this.state.autoOk}
                          maxDate   = {this.state.filter._DataFineScadenza}
                          onChange  = {(event, date) => this.handleChangeFilterDate(date, "DataInizioScadenza")}
                          value     = {this.state.filter._DataInizioScadenza}
                        />
                    </Col>
                    <Col sm12={3}>
                        <DatePicker
                          floatingLabelText={LABEL_EndExpiration[USERLANGUAGE]}
                          autoOk    = {this.state.autoOk}
                          minDate   = {this.state.filter._DataInizioScadenza}
                          onChange  = {(event, date) => this.handleChangeFilterDate(date, "DataFineScadenza")}
                          value     = {this.state.filter._DataFineScadenza}
                        />
                    </Col>
                    {/*<Col sm12={2}></Col>
                    <Col sm12={1}>
                      <center><RaisedButton className="button-table" icon={<IconFilter/>} onClick={this.handleOpenFilterDialog} buttonStyle={STYLES.sg_Button} /></center>
                    </Col>*/}
                  </Row>
                  <Row style={styles.filterRow}>
                    <Col sm12={9}></Col>
                    <Col sm12={3}>
                    <SelectField
                          floatingLabelText={LABEL_OrderBy[USERLANGUAGE]}
                          value={this.state.ordinaPer}
                          onChange={this.handleOrderChange}
                        >
                          <MenuItem value={"Nome"}            primaryText={LABEL_Name[USERLANGUAGE]}        rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"NomeDESC"}        primaryText={LABEL_Name[USERLANGUAGE]}        rightIcon={<IconArrowDown />}/>
                          <MenuItem value={"Descrizione"}     primaryText={LABEL_Description[USERLANGUAGE]} rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"DescrizioneDESC"} primaryText={LABEL_Description[USERLANGUAGE]} rightIcon={<IconArrowDown />}/>
                          <MenuItem value={"Scadenza"}        primaryText={LABEL_Expiration[USERLANGUAGE]}  rightIcon={<IconArrowUp />}/>
                          <MenuItem value={"ScadenzaDESC"}    primaryText={LABEL_Expiration[USERLANGUAGE]}  rightIcon={<IconArrowDown />}/>
                        </SelectField>
                    </Col>
                  </Row>
                  {USERINFO != null && <Row>
                      { //AGGIUNGI
                        this.state.selectedList.length === 0 &&
                        <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconAdd />} onClick={this.handleOpenAddModify} buttonStyle={STYLES.sg_Button} />
                        </Col>
                      }
                      { //MODIFICA
                        this.state.selectedList.length === 1 &&
                        <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconEdit />} onClick={this.handleOpenAddModify} buttonStyle={STYLES.sg_Button} />
                        </Col>
                      }
                      { //ELIMINA
                        this.state.selectedList.length > 0 &&
                        <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconDelete />} onClick={this.handleDeleteButton} buttonStyle={STYLES.sg_Button} />
                        </Col>
                      }
                      { //VISUALIZZA DETTAGLIO
                        this.state.selectedList.length === 1 &&
                        <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconShow />} onClick={this.handleOpenAddModifyOnlyRead} buttonStyle={STYLES.sg_Button} />
                        </Col>
                      }
                      { //VISUALIZZA DETTAGLIO
                        (this.state.filter.ID !== null || this.state.filter.Nome !== null || this.state.filter.DataInizioScadenza !== null || this.state.filter.DataFineScadenza !== null || this.state.filter.Descrizione !== null ) &&
                        <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconDeleteFilter />} onClick={this.handleDeleteAllFilters} buttonStyle={STYLES.sg_Button} />
                        </Col>
                      }
                      <Col sm12={1}>
                          <RaisedButton className="button-table" icon={<IconRefresh />} onClick={() => this.props.dispatch(getHoldingList(this.state.filter))} buttonStyle={STYLES.sg_Button} />
                      </Col>
                  </Row>}
                </Grid> 

                <Table
                  className       = "shadow"
                  height          = { (window.innerHeight - 500) + "px" }
                  fixedHeader     = { this.state.fixedHeader}
                  fixedFooter     = { this.state.fixedFooter}
                  selectable      = { this.state.selectable}
                  multiSelectable = { this.state.multiSelectable}
                  onRowSelection  = { this.handleRowSelection}
                  fixedFooter     = { true }
                  >
                  <TableHeader
                    displaySelectAll  = { this.state.showCheckboxes  }
                    adjustForCheckbox = { this.state.showCheckboxes  }
                    enableSelectAll   = { this.state.enableSelectAll }>
                        <TableRow>
                            <TableHeaderColumn style={{width: "30%"}} tooltip="">{LABEL_Name[USERLANGUAGE]}        </TableHeaderColumn>
                            <TableHeaderColumn style={{width: "40%"}} tooltip="">{LABEL_Description[USERLANGUAGE]} </TableHeaderColumn>
                            <TableHeaderColumn style={{width: "30%"}} tooltip="">{LABEL_Expiration[USERLANGUAGE]}  </TableHeaderColumn>
                            <TableHeaderColumn style={{width: "30%"}} tooltip="">{LABEL_NumberDays[USERLANGUAGE]}  </TableHeaderColumn>
                        </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox  = {this.state.showCheckboxes}
                    deselectOnClickaway = {this.state.deselectOnClickaway}
                    showRowHover        = {this.state.showRowHover}
                    stripedRows         = {this.state.stripedRows}
                  >
                      { this.props.holdingList != null &&
                        this.props.holdingList.map( (row, index) => (
                          <TableRow key={index} selected={this.isSelectedRow(index)} style={{background: this.getRowColorFrom(row.Scadenza)}}>
                            <TableRowColumn style={{width: "30%"}} > { row.Nome }         </TableRowColumn>
                            <TableRowColumn style={{width: "40%"}} > { row.Descrizione }  </TableRowColumn>
                            <TableRowColumn style={{width: "30%"}} > { row.Scadenza === null ? LABEL_NoExpiryDate[USERLANGUAGE] : momentformat(row.Scadenza).format("DD-MM-YYYY") }     </TableRowColumn>
                            <TableRowColumn style={{width: "30%"}} > { this.dateDifferenceToday(row.Scadenza) +" "+LABEL_Days[USERLANGUAGE] }  </TableRowColumn>
                          </TableRow>
                        ))
                      }
                      { this.props.holdingList != null && this.props.holdingList.length == 0 && 
                        <TableRow selectable={false} hoverable={false} hovered={false} selectable={false} striped={false}>
                          <TableRowColumn><center>{LABEL_NoResult[USERLANGUAGE]}</center></TableRowColumn>
                        </TableRow>
                      }
                  </TableBody>
                  <TableFooter
                    adjustForCheckbox={true}
                  >
                    <TableRow>
                      <TableRowColumn><IconLabel style={{ color : styles.color.scaduta }}/> {LABEL_ExpiredLicense[USERLANGUAGE]} </TableRowColumn>
                      <TableRowColumn><IconLabel style={{ color : styles.color.inScadenza } } /> {LABEL_Expiring[USERLANGUAGE]}     </TableRowColumn>
                    </TableRow>
                  </TableFooter>
                </Table>

                <Dialog
                  title={this.state.selectedList.length === 0 ? LABEL_DIALOG_HoldingNew[USERLANGUAGE] : LABEL_DIALOG_HoldingModify[USERLANGUAGE]}
                  actions={addModifyDialogAction}
                  modal={true}
                  contentStyle={styles.filterDialog}
                  open={this.state.showAddModify.opened}
                >
                  <Grid>
                  <Row>
                    <Col sm12={2}></Col>
                    <Col sm12={8}>
                      <TextField className="input-label"
                        onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Nome")}
                        hintText={LABEL_Enter_Name[USERLANGUAGE]}
                        floatingLabelText={LABEL_Name[USERLANGUAGE]}
                        fullWidth={true}
                        errorText={this.state.showAddModify.data.msgErrorNome}
                        fullWidth={true}
                        disabled={this.state.showAddModify.modify == true ? true : false}
                        value={ this.state.showAddModify.data.Nome === null  ? "" : this.state.showAddModify.data.Nome }/>
                    </Col>
                    <Col sm12={2}></Col>
                  </Row>
                  <Row> 
                    <Col sm12={2}></Col>
                    <Col sm12={8}>
                      <TextField className="input-label"
                        onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Descrizione")}
                        hintText={LABEL_Enter_Description[USERLANGUAGE]}
                        floatingLabelText={LABEL_Description[USERLANGUAGE]}
                        errorText={this.state.showAddModify.data.msgErrorDescrizione}
                        fullWidth={true}
                        disabled={this.state.showAddModify.modify == true ? true : false}
                        rows={2}
                        rowsMax={5}
                        multiLine={true}
                        value={ this.state.showAddModify.data.Descrizione === null  ? "" : this.state.showAddModify.data.Descrizione }/>
                    </Col>
                    <Col sm12={2}></Col>
                  </Row>
                  <Row> 
                    <Col sm12={4}></Col>
                    <Col sm12={4}>
                      <DatePicker
                        floatingLabelText={LABEL_Expiration[USERLANGUAGE]}
                        autoOk   = {this.state.autoOk}
                        minDate  = {this.state.minDateDue}
                        onChange = {this.handleOnChangeAddModifyScadenza}
                        value    = {this.state.showAddModify.data.Scadenza == null ? {} : new Date(this.state.showAddModify.data.Scadenza)}
                        errorText={this.state.showAddModify.data.msgErrorScadenza}
                        fullWidth={true}
                      />
                    </Col>
                    <Col sm12={4}></Col>
                  </Row>
                  </Grid>
                </Dialog>
        </div>


      </div>;
  }
}

function mapStateToProps(state) {
  const { holdingReducer } = state;
  const { isFetching,  isAuthenticated, holdingList, errorMessage, toRefreshOnRender  } = holdingReducer;
	return { 
    isFetching,
    holdingList,
    isAuthenticated,
    errorMessage,
    toRefreshOnRender
  };
}

export default connect(mapStateToProps)(Holding);


// WEBPACK FOOTER //
// ./src/Containers/Holding.js